import _ from 'lodash';

/* @ngInject */
export default function licensesFactory($http, $q, moment, HPConfig, LicenseTemplateUrls, LicenseTypes) {
    return {
        getLicenses,
        deleteLicense,
        getActiveStates,
        validateLicense,
        addLicense,
        licenseUpdateValidation,
        updateLicense,
    };

    function getLicenses(organizationId) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Licenses`,
            method: 'GET',
            params: {
                OrganizationId: organizationId,
            },
        });
    }


    function deleteLicense(params) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/DeleteLicense`,
            method: 'POST',
            data: params,
        });
    }
    function processActiveStates(states) {
        _.each(states, (state) => {
            _.extend(
                state,
                {
                    Url: LicenseTemplateUrls[state.StateCode] || LicenseTemplateUrls[state.LicenseTypes[0].LicenseCategoryTypeId] || '',
                },
            );
        });

        return states;
    }

    function getActiveStates() {
        const deferred = $q.defer();

        $http.get(`${HPConfig.heroProApi}Contractor/LicensePageData`).then((data) => {
            deferred.resolve(processActiveStates(data.data.LicenseTypes.LicenseStates));
        });

        return deferred.promise;
    }

    function validateLicense(licenseNumber, licenseType, contractorId, jurisdiction, expiration) {
        const data = {
            LicenseNumber: licenseNumber,
            LicenseTypeId: licenseType,
            EnsureUnique: true,
            ContractorLocationId: contractorId,
            LicenseExpirationDate: expiration || null,
            Jurisdiction: jurisdiction || null,
        };

        return $http.post(`${HPConfig.heroProApi}Contractor/validateLicense`, data);
    }

    function convertToISO(date) {
        if (date === null || date.length < 8) {
            return null;
        } else if (date && date.length === 10) {
            const exp = date.split('-');
            const exp2 = date.split('/');

            return exp.length > 1 ? `${exp[exp.length - 1]}-${exp[0]}-${exp[exp.length - 2]}` : `${exp2[exp2.length - 1]}-${exp2[0]}-${exp2[exp2.length - 2]}`;
        }
        return `${date.substring(4)}-${date.substring(0, 2)}-${date.substring(2, 4)}`;
    }

    function processLicenseData(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction) {
        const request = {
            ContractorLocationId: contractorId,
            License: {
                OrganizationId: orgId,
                OrganizationLicenseTypeId: licenseType,
                LicenseNumber: licenseNumber,
                IntegrationType: integrationType,
                Jurisdiction: jurisdiction,
                LicenseExpireDate: null,
                OrganizationLicenseStatusId: 1, // valid license
            },
            Document: null,
        };

        if (expiration && moment(convertToISO(expiration)).isValid) {
            request.License.LicenseExpireDate = moment(convertToISO(expiration));
        }

        return request;
    }

    function addLicense(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction) {
        const data = processLicenseData(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction);

        return $http.post(`${HPConfig.heroProApi}Contractor/AddLicense`, data);
    }

    function licenseUpdateValidation(licenseTypeId) {
        return licenseTypeId !== LicenseTypes.CSLB || licenseTypeId !== LicenseTypes.CILB;
    }

    function updateLicense(contractorId, orgId, licenseId, licenseType, licenseNumber, expiration, integrationType, jurisdiction) {
        const data = processLicenseData(contractorId, orgId, licenseType, licenseNumber, expiration, integrationType, jurisdiction);
        data.License.OrganizationLicenseId = licenseId;

        return $http.post(`${HPConfig.heroProApi}Contractor/UpdateLicense`, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/licensesFactory.js